export default __webpack_public_path__ + "static/media/snailpaw3.01cb4b23.jpeg";